import React from 'react';
import PropTypes from 'prop-types';
import ModalContainer from '../../Global/Modals/ModalContainer';

const AllocateLicenceModal = ({ children, modalIsOpen, onCloseClick }) => (
  <ModalContainer
    isOpen={modalIsOpen}
    closeModal={onCloseClick}
    label="Allocate licence modal"
  >
    {children}
  </ModalContainer>
);

AllocateLicenceModal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  modalIsOpen: PropTypes.bool.isRequired,
  onCloseClick: PropTypes.func,
};

export default AllocateLicenceModal;



// WEBPACK FOOTER //
// ./library/app/components/Account/LicenceManager/AllocateLicenceModal.js